import * as Dialog from "@radix-ui/react-dialog";

import ModalModel from "../../../Models/Modal/Modal.Model";
import { ModalHeader } from "./Components/Modal.Layout";

const defaultStyle = {
  content: {
    margin: "auto",
    borderRadius: "8px",
    boxShadow: "0px 2px 4px rgba(0,0,0, 0.2)",
    maxWidth: "fit-content",
    minHeight: "300px",
    maxHeight: "fit-content",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    overflowX: "hidden",
    overflowY: "auto",
    padding: "0px",
    backgroundColor: "#F7F7F7",
  },
};

export const SSModal = () => {
  // We are starting our transition to hooks and the pullstate approach to everything.
  const { modalContent, modalHeader, showModal, modalHeight, modalWidth, shouldCloseOnOverlayClick } = ModalModel.useState();

  const closeModal = () => {
    ModalModel.hideModal();
  };
  let style: any = { ...defaultStyle };
  if (modalWidth) {
    // style.left = "auto"
    // style.right = "auto"
    style.content = {
      ...style.content,
      height: `${modalHeight}px`,
      width: `${modalWidth}px`,
    };
  }

  return (
    <Dialog.Root open={showModal} onOpenChange={closeModal}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[9999] bg-[rgba(94,84,80,0.2)] backdrop-blur-sm flex items-center justify-center">
          <Dialog.Content
            className="bg-white rounded-lg shadow-lg max-w-md w-full p-5"
            style={style.content}
            onEscapeKeyDown={closeModal}
            onPointerDownOutside={shouldCloseOnOverlayClick ? closeModal : undefined}
            onInteractOutside={shouldCloseOnOverlayClick ? closeModal : undefined}
          >
            <Dialog.Title className="sr-only">
              {modalHeader || "Start Shift Modal"}
            </Dialog.Title>
            {modalHeader && <ModalHeader>{modalHeader}</ModalHeader>}
            <div className="p-5 flex items-center justify-center">{modalContent}</div>
          </Dialog.Content>
        </Dialog.Overlay>
      </Dialog.Portal>
    </Dialog.Root>
  );
};
